import { Record } from 'immutable';

export default class Holiday extends Record({
  date: null,
  type: null,
}) {
}
